// extracted by mini-css-extract-plugin
export default {"frame":"Confirm_frame__YpHLK","center":"Confirm_center__Ym9wT","close":"Confirm_close__CjAaR"};